import Yup from '../../../helpers/custom-yup'
import React from 'react'
import styled from 'styled-components'
import StyledFlexContainer from './../../../components/containers/flex-container.component'
import { connect } from 'react-redux'
import { isMobile } from '../../../services/breakpoints.service'
import { PRIMARY_LIGHT } from '../../../styles/colors.style'
import { breakpoints } from './../../../constants/breakpoits.constants'
import { toastActions } from '../../../actions/toast.actions'
import { Formik } from 'formik'
import { PassengerService } from './../../../services/passenger.service'
import { bindActionCreators } from 'redux'
import { CheckboxToggleInput } from './../../../components/form-components/inputs.component'
import { Creators as SiteCreators } from '../../../ducks/site/site'
import { ClientRegisterVerificationService } from './../../../services/client-register-verification.service'
import {
	TextInput,
	SelectInput,
	DateInput,
} from '../../../components/form-components/inputs.component'
import './styles/passengers-data.style.css'
import moment from 'moment'

const marginTop = 3.2
const clientRegistrationStatus = {
	ACTIVE_STATUS: 0,
}

let timer = ''

class PassengerForm extends React.Component {
	constructor(props) {
		super(props)
		if (props.position == 0 && !!props.user) {
			this.initialValues = {
				name: null,
				documentnumber: null,
				documenttype: documentOptions[0].value,
				loggedpassenger: true,
				[`passenger_birthdate_${props.position}`]: null,
			}
		} else if (
			props.position == 1 &&
			!!props.user &&
			!!props.user.benefitDataModel &&
			!!props.user.benefitDataModel.caregiverCpf
		) {
			if (props.user.benefitDataModel) {
				const { caregiverCpf, caregiverName, caregiverBirthday } =
					props.user.benefitDataModel
				this.initialValues = {
					name: caregiverName,
					documentnumber: caregiverCpf,
					documenttype: documentOptions[1].value,
					loggedpassenger: false,
					passenger_birthdate: caregiverBirthday,
				}
			}
		} else {
			this.initialValues = {
				name: null,
				documentnumber: null,
				documenttype: documentOptions[0].value,
				loggedpassenger: false,
				passenger_birthdate: null,
			}
		}

		this.schema = Yup.object().shape({
			name: Yup.string()
				.name()
				.nullable()
				.required('Informe o nome completo'),
			documenttype: Yup.string()
				.required('Informe o tipo de documento')
				.nullable(),
			documentnumber: Yup.string().when('documenttype', {
				is: 'Cpf',
				then: Yup.string().cpf().required('Informe o CPF'),
				otherwise: Yup.string()
					.required('Informe o número do documento')
					.nullable(),
			}),
			[`passenger_birthdate_${props.position}`]: Yup.string()
				.birthday()
				.required('Informe sua data de nascimento')
				.min('10', 'Favor digitar a data completa')
				.nullable(),
		})

		this.state = {
			timestamp: '',
			isMoveflexClient: false,
			passengers: [],
			showOptions: false,
			notSetLoggedPassenger: true,
			isBirthdayValid: true,
		}

		this.renderFormik = renderFormik.bind(this)
		this.verifyRegistration = verifyRegistration.bind(this)
		this.loadDocument = loadDocument.bind(this)
		this.setPassengers = this.setPassengers.bind(this)
		this.setLoggedPassenger = setLoggedPassenger.bind(this)
	}

	getFormRef() {
		return this.refs.form
	}

	setPassengers = (actuals) => {
		this.setState({ passengers: actuals })
	}

	componentDidMount() {
		this.props.loadOptions()
		this.props.setPassengers(this.setPassengers)
	}

	showOptions = () => {
		this.setState({ showOptions: true })
	}

	hideOptions = () => {
		this.setState({ showOptions: false })
	}

	onClear = (index, props) => {
		const passenger = this.props.passengers[index]
		PassengerService.deletePassenger(passenger.value.id).then((response) => {
			if (response) {
				props.setFieldValue('name', null)
				props.setFieldValue('documenttype', 'Rg')
				props.setFieldValue('documentnumber', null)

				this.props.removeActivePassenger(passenger)
				this.props.user !== null ? this.props.loadOptions() : null
			}
		})
	}

	componentWillUnmount() {
		clearTimeout(timer)
	}

	render() {
		return (
			<div>
				<span className="blue f-x-large">{this.props.formTitle}</span>
				<Formik
					ref="form"
					render={this.renderFormik.bind()}
					onSubmit={this.props.onSubmit}
					validationSchema={this.schema}
					initialValues={this.initialValues}
				/>
			</div>
		)
	}
}

function verifyRegistration() {
	const { documenttype, documentnumber } = this.refs.form.state.values

	const timestamp = +new Date()
	this.setState({ timestamp, isMoveflexClient: false })

	ClientRegisterVerificationService.checkRegistration({
		documenttype,
		documentnumber,
	}).then(({ data }) => {
		if (data === null) return
		if (this.state.timestamp != timestamp) return
		const isMoveflexClient =
			data.status == clientRegistrationStatus.ACTIVE_STATUS
		this.setState({ isMoveflexClient })
	})
}

function setLoggedPassenger(props) {
	const {
		user,
		passengers,
		loadOptions,
		addActivePassenger,
		removeActivePassenger,
		setLoggedPassengerAlreadySet,
	} = this.props

	const { notSetLoggedPassenger } = this.state

	const passengerList = passengers.filter((p) => {
		if (user) {
			return p.value.documentNumber === user.documentnumber
		}
	})

	if (props.values.loggedpassenger && notSetLoggedPassenger) {
		let formattedDate

		if (user && user.birthday) {
			formattedDate = new Date(user.birthday).toISOString().split('T')[0]
		}

		this.setState(
			{ notSetLoggedPassenger: false, isBirthdayValid: !!formattedDate },
			() => {
				const { rebookingData } = this.props

				let passenger = {
					name: user.name,
					documentType: 'Cpf',
					documentNumber: user.cpf,
					birthdate: formattedDate,
				}

				if (rebookingData && rebookingData.isRebooking) {
					const ticket = this.props.tickets.find(
						(ticket) => ticket.ticketId == rebookingData.rebookingTicketId
					)

					passenger = {
						name: ticket.passengerName,
						documentType:
							documentOptions[ticket.passengerDocumentNumber - 1].value,
						documentNumber: ticket.passengerDocumentType,
						birthdate: ticket.passengerBirthDate.split('T')[0],
					}
				}

				props.setFieldValue('name', passenger.name)
				props.setFieldValue('documenttype', passenger.documentType)
				props.setFieldValue('documentnumber', passenger.documentNumber)
				props.setFieldValue(
					`passenger_birthdate_${this.props.position}`,
					moment(user.birthday).format('DD-MM-YYYY')
				)

				if (passengerList) {
					const loggedPassenger = {
						value: {
							id: 0,
							identityUserId: user.id,
							name: user.name,
							documentType: 2,
							documentNumber: user.cpf,
						},
						label: user.name,
					}

					addActivePassenger(loggedPassenger)
					loadOptions()
				}
				setLoggedPassengerAlreadySet(true)
			}
		)
	}

	if (
		props.values.loggedpassenger === false &&
		notSetLoggedPassenger === false
	) {
		this.setState({ notSetLoggedPassenger: true }, () => {
			props.setFieldValue('name', '')
			props.setFieldValue('documenttype', 'Rg')
			props.setFieldValue('documentnumber', '')
			props.setFieldValue(`passenger_birthdate_${this.props.position}`, '')

			if (passengerList) {
				removeActivePassenger({ documentnumber: user.cpf })
				loadOptions()
			}
			setLoggedPassengerAlreadySet(false)
		})
	}
}

function renderFormik(props) {
	const {
		user,
		position,
		selectedPriceGoing,
		selectedPriceReturn,
		loggedPassengerAlreadySet,
		setShowToggleLoggedPassenger,
		rebookingData,
	} = this.props

	if (user) {
		this.setLoggedPassenger(props)
	}

	const hasPoints = selectedPriceGoing.points || selectedPriceReturn.points

	const passengerText = hasPoints
		? ''
		: this.state.isMoveflexClient
		? 'Passageiro já é um cliente Muviflex e irá acumular pontos!'
		: 'Cadastre o passageiro no Muviflex para acumular pontos!'

	const form = this.refs.form
	const documentnumber = form && form.state.values.documentnumber
	const showPassengerText = !['', null].includes(documentnumber)
	const isBenefitUser = this.props.user && this.props.user.isEligibleForBenefit
	const isRebooking = rebookingData && rebookingData.isRebooking
	const isBtnMePassengerEnable = isBenefitUser || isRebooking
	const isMePassenger = form && form.state.values.loggedpassenger
	const isEditingEnabled = isMePassenger

	const { values } = props

	return (
		<StyledForm noValidate>
			<StyledFlexContainer marginTop={isMobile() ? marginTop : 1}>
				<div className="name-container">
					<TextInput
						id="name"
						{...props}
						disabled={isEditingEnabled}
						maxLength={32}
						className="col-6"
						position={position}
						onFocus={() => {
							this.showOptions()
						}}
						handleBlur={() => {
							timer = setTimeout(() => this.hideOptions(), 200)

							const { name, documentnumber } =
								this.refs.form.state.values

							const {
								loadOptions,
								removeActivePassenger,
								setLoggedPassengerAlreadySet,
							} = this.props
							if (
								name === '' &&
								(documentnumber !== '' || documentnumber !== null)
							) {
								props.setFieldValue('name', null)
								props.setFieldValue('documenttype', 'Rg')
								props.setFieldValue('documentnumber', null)

								removeActivePassenger({
									name,
									documentnumber,
								})

								loadOptions()

								if (documentnumber === user.cpf) {
									setShowToggleLoggedPassenger(true)
									setLoggedPassengerAlreadySet(false)
									props.setFieldValue('loggedpassenger', false)
								}
							}
						}}
						attribute="passenger"
						label="Nome completo"
					/>
					{this.props.passengers.length > 0 ? (
						<div
							className={`name-option-container show-options-${this.state.showOptions}`}>
							{this.props.passengers.map((p, index) => {
								return (
									<div
										key={index}
										className="name-option-container-clear">
										<span
											className={`name-option`}
											id={index}
											onClick={() => {
												const passenger =
													this.props.passengers[index]

												props.setFieldValue(
													'name',
													passenger.value.name
												)

												if (passenger.value.documentType === 1)
													props.setFieldValue('documenttype', 'Rg')
												else
													props.setFieldValue(
														'documenttype',
														'Cpf'
													)
												props.setFieldValue(
													'documentnumber',
													passenger.value.documentNumber
												)

												this.props.loadOptions(
													passenger.value.id,
													position
												)

												const { name, documentnumber } =
													this.refs.form.state.values

												this.props.addAndRemoveActualPassenger(
													{
														name,
														documentnumber,
													},
													passenger
												)

												if (
													user &&
													passenger.value.name === user.name &&
													passenger.value.documentNumber ===
														user.cpf
												) {
													setShowToggleLoggedPassenger(false)
												} else if (
													user &&
													passenger.value.name !== user.name &&
													passenger.value.documentNumber !==
														user.cpf
												) {
													props.setFieldValue(
														'loggedpassenger',
														false
													)
													setShowToggleLoggedPassenger(true)
												}

												this.setState({
													showOptions: false,
												})
											}}>
											{p.value.name}
										</span>
										<div
											className="x-clear"
											onClick={() => this.onClear(index, props)}>
											x
										</div>
									</div>
								)
							})}
						</div>
					) : null}
				</div>
				<StyledDocument className="col-3">
					<SelectInput
						{...props}
						multi={false}
						disabled={isEditingEnabled}
						id="documenttype"
						label="Documento"
						position={position}
						attribute="documenttype"
						options={documentOptions}
						defaultValue={documentOptions[0]}
						onValueChange={(value) => {
							setTimeout(() => {
								this.verifyRegistration()
								props.onValueChange && props.onValueChange(value)
							})
						}}
					/>
					{showPassengerText && !isMobile() && (
						<div className="is-client passenger-text">
							<span className="f-small">{passengerText}</span>
						</div>
					)}
				</StyledDocument>
				<StyledDocument className="col-2">
					<TextInput
						{...props}
						maxLength={values && values.documenttype === 'Cpf' ? 11 : 32}
						disabled={isEditingEnabled}
						id="documentnumber"
						label="N.º do documento"
						position={position}
						attribute="documentnumber"
						handleBlur={(value) => {
							this.verifyRegistration()
							props.handleBlur(value)

							const { documentnumber, name } =
								this.refs.form.state.values

							if (user && user.cpf !== documentnumber)
								setShowToggleLoggedPassenger(true)
							else setShowToggleLoggedPassenger(false)

							if (
								user &&
								user.name == name &&
								documentnumber == user.cpf &&
								loggedPassengerAlreadySet
							) {
								props.setFieldValue('name', null)
								props.setFieldValue('documenttype', 'Rg')
								props.setFieldValue('documentnumber', null)

								setShowToggleLoggedPassenger(true)
							}
						}}
					/>
					{showPassengerText && isMobile() && (
						<div className="is-client">
							<span className="f-small">{passengerText}</span>
						</div>
					)}
				</StyledDocument>
				<StyledDocument className="col-2">
					<DateInput
						{...props}
						disabled={isEditingEnabled}
						id={`passenger_birthdate_${position}`}
						label="Data de nascimento"
					/>
					{showPassengerText && isMobile() && (
						<div className="is-client">
							<span className="f-small">{passengerText}</span>
						</div>
					)}
				</StyledDocument>
				{position === 0 && user ? (
					<div className={`loggedpassenger-container`}>
						<CheckboxToggleInput
							disabled={isBtnMePassengerEnable}
							label="Sou passageiro"
							id="loggedpassenger"
							{...props}
						/>{' '}
					</div>
				) : null}
			</StyledFlexContainer>
		</StyledForm>
	)
}

function loadDocument(value, props, action) {
	if (value && action === 'select-option') {
		if (value.documentType === 1) {
			props.setFieldValue('documenttype', 'Rg')
			props.setFieldValue('documentnumber', value.documentNumber)
		} else {
			props.setFieldValue('documenttype', 'Cpf')
			props.setFieldValue('documentnumber', value.documentNumber)
		}
	}
}

const StyledDocument = styled.div`
	.is-client {
		color: ${PRIMARY_LIGHT};
		margin-top: 10px;
		position: absolute;
	}
	@media screen and (max-width: ${breakpoints.IPHONE_SE}px) {
		.is-client {
			margin-top: 3px;
		}
	}
`

const StyledForm = styled.form`
	transform: translateY(-${marginTop}rem);
	margin-bottom: 3em;

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		transform: unset;
	}
`

const documentOptions = [
	{ value: 'Rg', label: 'RG/PASSAPORTE' },
	{ value: 'Cpf', label: 'CPF' },
]

const mapStateToProps = (store) => ({
	rebookingData: store.ticketSale.rebookingData,
	tickets: store.clientTicketModal.tickets,
})

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			toastError: toastActions.danger,
			toastSuccess: toastActions.success,
			showLoading: SiteCreators.showLoading,
			hideLoading: SiteCreators.hideLoading,
		},
		dispatch
	)

const ConnectedPassengerForm = connect(
	mapStateToProps,
	mapDispatchToProps,
	null,
	{
		forwardRef: true,
	}
)(PassengerForm)

export { ConnectedPassengerForm as PassengerForm }
